var _module_exports = "\n<div ng-if=\"item && item.root\" translate>rulechain.root</div>\n";;
var path = '/rulechain/rulechain-card.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;